import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { authMiddleware, initializeAuth } from '../middleware/authMiddleware';
import { logout, lockSession } from './authSlice';
import { setAuthFailureHandler, setBiometricLoginHandler } from '../utils/axiosConfig';

const store = configureStore({
    reducer: {
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(authMiddleware),
});

setAuthFailureHandler(() => store.dispatch(logout()));
setBiometricLoginHandler(() => store.dispatch(lockSession()));

export const initializeStore = () => initializeAuth(store);

export default store;
